import axios from 'axios'
import User from '../model/user'

export default {
  state: {
    status: '',
    token: localStorage.getItem('token') || null,
    user: {},
    isLoggedIn: false,
    error: null
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, payload) {
      const token = payload && payload.token ? payload.token : null
      const user = payload ? payload.user : undefined
      state.status = 'success'
      state.token = token
      if (user !== undefined) {
        state.user = user
      }
    },
    set_auth_user(state, user) {
      state.user = user || {}
    },
    auth_error(state) {
      state.status = 'error'
    },
    logout(state) {
      state.status = ''
      state.token = ''
      state.user = {}
    }
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    user: (state) => state.user,
    authStatus: (state) => state.status
    //error: s => s.error
  },
  actions: {
    login({ commit }, loginForm) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios
          .post('/api/login_check', loginForm)
          .then(({ data }) => {
            const token = data.token
            const user = data.user
            // console.log(token)
            localStorage.setItem('token', token)
            localStorage.setItem('isLoggedIn', true)
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            commit('auth_success', { token, user: false })
            resolve(data)
          })
          .catch((error) => {
            commit('auth_error')
            reject(error.response || error)
          })
      })
    },
    // getuid() {
    //   const user = this.user;
    //   return user ? user.uid : null;
    // },
    register({ commit }, registerData) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({
          url: '/ru/api/public/sign/register',
          data: registerData,
          method: 'POST'
        })
          .then((resp) => {

            resolve(resp)
          })
          .catch((err) => {
            // commit('auth_error', err)
            // localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('isLoggedIn')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
    async setUserToken({commit}, data) {
      const token = data.token
      localStorage.setItem('token', token)
      localStorage.setItem('isLoggedIn', true)
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      commit('auth_success', { token, user: undefined })
      try {
        const response = await User.checkUser()
        commit('set_auth_user', response.data)
      } catch (e) {
        commit('set_auth_user', {})
      }
    }
  },
  modules: {
    axios,
    User
  }
}
